import React, { ChangeEvent } from 'react';
import { Input, cn } from '@chapche/ui';

interface TextInputProps {
    label: string;
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    type?: string;
    hasError?: boolean;
    inputClassName?: string;
    labelClassName?: string;
}

/**
 * Reusable text/email input for login forms.
 */
const TextInput = ({
    label,
    value,
    onChange,
    type = 'text',
    hasError = false,
    inputClassName = 'login__input',
    labelClassName = 'block__text login__label',
}: TextInputProps) => (
    <label className={cn(labelClassName, 'flex flex-col gap-8', hasError && 'login__label_error')}>
        {label}
        <Input
            fullWidth
            className={cn('mt-0', inputClassName, hasError && 'login__input_error')}
            type={type}
            value={value}
            onChange={onChange}
            autoComplete="off"
            state={hasError ? 'error' : 'default'}
        />
    </label>
);

export default TextInput;
